import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import styles from './GalleryItem.module.scss';
import VideoPlayer from './Video/VideoPlayer';

const GalleryItem = ({
  type,
  imageUrl,
  videoCoverImage,
  youtubeVideoId,
  text,
}) => {
  const [imgUrl, setImageUrl] = useState(null);
  const [isVideo, setIsVideo] = useState(false);
  useEffect(() => {
    if (type === 'video') {
      setIsVideo(true);
      if (videoCoverImage === '') {
        if (youtubeVideoId !== '') {
          setImageUrl(`http://i3.ytimg.com/vi/${youtubeVideoId}/hqdefault.jpg`);
        } else {
          // console.log('use video cover image');
          setImageUrl(videoCoverImage);
        }
      } else {
        setImageUrl(videoCoverImage);
      }
    } else {
      setIsVideo(false);
      setImageUrl(imageUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.wrapper}>
      {!isVideo && (
        <>
          {imageUrl && <img src={imgUrl} alt="img" />}
          {text && <span>{text}</span>}
        </>
      )}
      {isVideo && (
        <>
          <VideoPlayer thumbnail={imgUrl} youtubeId={youtubeVideoId} />
          {text && <span>{text}</span>}
        </>
      )}
    </div>
  );
};

GalleryItem.propTypes = {
  type: string.isRequired,
  imageUrl: string.isRequired,
  videoCoverImage: string.isRequired,
  youtubeVideoId: string.isRequired,
  text: string.isRequired,
};

export default GalleryItem;
